import { z } from "zod";
import { isValidMacroKey } from "@/lib/source-types";

const TRACKING_SLOT_RE = /^trackingField(?:[1-9]|1[0-9]|20)$/;

/**
 * The traffic-source configure step.
 *
 * The validation is the drawer's own, moved out of the save handler: it built
 * a `Record<string, string>` of errors by hand, keyed `tracking:<macro>`, and
 * then announced "Fix the highlighted fields" in a toast. The rules are the
 * same; what changes is that they run as the user types and land on the field.
 */
export const trafficSourceFormSchema = z.object({
  name: z.string().trim().min(1, "Обязательное поле").max(200),
  clickUrlTemplate: z.string().max(2048),
  /** Comma-separated upstream macros carrying cost on the click URL. */
  costMacros: z.string().refine((v) => {
    const bad = splitMacros(v).find((m) => !isValidMacroKey(m));
    return !bad;
  }, "Среди значений есть недопустимое имя макроса"),
  trackingFieldMap: z.record(z.string(), z.string()).refine(
    (map) =>
      Object.entries(map).every(([k, v]) => isValidMacroKey(k) && TRACKING_SLOT_RE.test(v)),
    "Каждый ключ — имя макроса, каждое место — trackingField1..20",
  ),
});

export type TrafficSourceFormValues = z.infer<typeof trafficSourceFormSchema>;

/** `spend, cpc` → ["spend", "cpc"]. Blanks dropped. */
export function splitMacros(v: string): string[] {
  return v
    .split(",")
    .map((m) => m.trim())
    .filter(Boolean);
}
